// extracted by mini-css-extract-plugin
export default {"root":"ReviewWidget_root__4mxcs"};